import './index.css';

import { useRef } from 'react';
import { Link } from 'react-router-dom';

import { gsap, useGSAP, MEDIA } from '@/utils/gsap';

const Footer = () => {
    const footerRef = useRef<HTMLElement>(null);

    useGSAP(
        () => {
            gsap.matchMedia().add(MEDIA.motionOk, () => {
                // 트리거 4개 대신 타임라인 하나에 ScrollTrigger 하나만 건다.
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: footerRef.current,
                        start: 'top bottom',
                        toggleActions: 'play none none none'
                    }
                });

                tl.from(
                    '.footer-text-box h3',
                    { y: 100, opacity: 0, duration: 1 },
                    0.3
                )
                    .from(
                        '.footer-link-box a',
                        { y: 100, opacity: 0, duration: 1, stagger: 0.2 },
                        0.5
                    )
                    .from(
                        '.footer-info-box',
                        { y: 20, opacity: 0, duration: 1 },
                        0.7
                    )
                    .from(
                        '.footer-content',
                        { y: 20, opacity: 0, duration: 1 },
                        0.9
                    );
            });
        },
        { scope: footerRef }
    );

    return (
        <footer className="footer-wrapper" ref={footerRef}>
            <div className="footer-sub-wrapper">
                <div className="footer-text-box">
                    <h3>be bold</h3>
                    <h3>be one</h3>
                    <h3>UNUS</h3>
                </div>
                <div className="footer-link-box">
                    <Link to="/about">About</Link>
                    <Link to="/portfolio">Portfolio</Link>
                    <Link to="/career">Career</Link>
                    <Link to="/contact">Contact</Link>
                </div>
                <div className="footer-info-box">
                    <div className="footer-info">
                        <p>
                            <span>Tel</span> 02-6925-5578
                        </p>
                        <p>
                            <span>Fax</span> 02-6925-5579
                        </p>
                        <p>
                            <span>Email</span> info@unuskorea.com
                        </p>
                        <p>
                            <span>Adresss</span> 서울 마포구 양화로 12길 24, 3층
                        </p>
                    </div>
                    <div className="footer-content">
                        All Contents of this proposal are the exclusive property
                        of UNUS KOREA.Inc
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
